import React, { useState } from 'react';
import Logo from './Logo';
import { ChevronDown, Menu, X } from 'lucide-react';
import { navigation } from '../mock';
import { useAuth } from '../context/AuthContext';

// Map child label to view + sub
const childRoute = {
  // Partners
  'Rewards': ['partners'],
  'Structure': ['partners'],
  // Investments
  'Packages': ['investments', 'packages'],
  'My Investments': ['investments', 'my'],
  'Installment Package': ['investments', 'installment'],
  'My Certificates': ['investments', 'certs'],
  // Portal Center
  'Wallet': ['portal-wallet'],
  'Deposit': ['portal-deposit'],
  'Withdraw': ['portal-withdraw'],
  'Transfer': ['portal-transfer'],
  'Dividend': ['portal-dividend'],
  'History': ['portal-history'],
  // Profile
  'KYC': ['profile-kyc'],
  'Authentication': ['profile-auth'],
  'Delivery Addresses': ['profile-addr'],
  // News
  'Ecosystem News': ['news'],
  // Setting
  'Change Password': ['change-password'],
};

const parentRoute = {
  'Partners': ['partners'],
  'Investments': ['investments', 'packages'],
  'Portal Center': ['portal-wallet'],
  'Share Transfer': ['share-transfer'],
  'Profile': ['profile-kyc'],
  'News': ['news'],
  'Setting': ['change-password'],
};

const Header = ({ onOpenPortal, onNavigate }) => {
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  const handleParent = (label) => {
    setOpen(null);
    setMobileOpen(false);
    if (label === 'Home') {
      onNavigate?.('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (!user) {
      onOpenPortal?.();
      return;
    }
    const route = parentRoute[label];
    if (route) onNavigate?.(route[0], route[1]);
  };

  const handleChild = (parentLabel, childLabel) => {
    setOpen(null);
    setMobileOpen(false);
    if (!user) {
      onOpenPortal?.();
      return;
    }
    const route = childRoute[childLabel];
    if (route) onNavigate?.(route[0], route[1]);
    else if (parentRoute[parentLabel]) {
      const p = parentRoute[parentLabel];
      onNavigate?.(p[0], p[1]);
    }
  };

  return (
    <div className="px-4 md:px-10">
      <div className="relative mx-auto max-w-[1240px] rounded-2xl border border-emerald-900/60 bg-gradient-to-r from-[#0a2116] via-[#092619] to-[#0a2116] backdrop-blur px-4 md:px-6 py-3 flex items-center justify-between">
        <button onClick={() => handleParent('Home')} className="focus:outline-none">
          <Logo />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navigation.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => setOpen(item.label)}
              onMouseLeave={() => setOpen(null)}
            >
              <button
                onClick={() => handleParent(item.label)}
                className="nav-pill flex items-center gap-1 rounded-full px-4 py-2 text-[14px] text-emerald-50/90 hover:bg-emerald-900/40 hover:text-white"
              >
                {item.label}
                {item.children && <ChevronDown size={14} className={`transition ${open === item.label ? 'rotate-180 text-emerald-400' : ''}`} />}
              </button>
              {item.children && open === item.label && (
                <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2 z-50">
                  <div className="min-w-[200px] rounded-xl border border-emerald-900/70 bg-[#07160e] shadow-2xl p-1.5">
                    {item.children.map((c) => (
                      <button
                        key={c.label}
                        onClick={() => handleChild(item.label, c.label)}
                        className="w-full text-left block px-3 py-2 text-sm text-emerald-100/85 hover:bg-emerald-900/40 hover:text-white rounded-lg"
                      >
                        {c.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <button className="lg:hidden text-emerald-100" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden mt-2 mx-auto max-w-[1240px] rounded-2xl border border-emerald-900/60 bg-[#07160e] p-3">
          {navigation.map((item) => (
            <div key={item.label} className="py-1">
              <button
                onClick={() => {
                  if (item.children) setOpen(open === item.label ? null : item.label);
                  else handleParent(item.label);
                }}
                className="w-full flex justify-between items-center px-3 py-2 text-emerald-100 hover:bg-emerald-900/40 rounded-lg"
              >
                <span>{item.label}</span>
                {item.children && <ChevronDown size={16} className={open === item.label ? 'rotate-180' : ''} />}
              </button>
              {item.children && open === item.label && (
                <div className="pl-5">
                  {item.children.map((c) => (
                    <button key={c.label} onClick={() => handleChild(item.label, c.label)} className="block w-full text-left px-3 py-1.5 text-sm text-emerald-200/80 hover:text-white">{c.label}</button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Header;
